import { Box, Skeleton } from "@mantine/core";
import { IconChevronLeft, IconDotsVertical, IconX } from "@tabler/icons-react";
import clsx from "clsx";

interface ChatHeaderSkeletonProps {
  onGoBack: () => void;
  onClose: () => void;
  className?: string;
}

export const ChatHeaderSkeleton = ({
  onGoBack,
  onClose,
  className,
}: ChatHeaderSkeletonProps) => {
  return (
    <Box
      data-testid={"chat-header-skeleton"}
      className={clsx(
        className,
        "bg-white w-full flex items-start justify-between sticky top-0 z-10"
      )}
      mih={66}
    >
      <Box className="flex items-center gap-2" mih={66}>
        <button
          className="m-2 cursor-pointer"
          aria-label="Back"
          onClick={onGoBack}
        >
          <IconChevronLeft
            height={24}
            width={24}
            color="var(--color-gray-dark)"
          />
        </button>
        <Skeleton height={40} width={40} circle animate />
      </Box>

      <Box
        className="flex flex-col gap-2 items-start px-4 grow"
        mih={66}
        pt={16}
      >
        <Skeleton height={16} width="40%" radius="xl" animate />
        <Skeleton height={14} width="22%" radius="xl" animate />
      </Box>

      <Box className="flex items-center gap-2 mr-2" mih={66}>
        <button className="p-2" aria-label="More options" disabled>
          <IconDotsVertical height={24} width={24} />
        </button>
        <button
          className="p-0 flex items-center cursor-pointer"
          aria-label="Close"
          onClick={onClose}
        >
          <IconX size={32} />
        </button>
      </Box>
    </Box>
  );
};
